import React, { useContext } from 'react';
import ClimateIcon from '../ClimateIcon/ClimateIcon';
import './style.css';
import { WindowSizeContext } from '/src/App';

const ClimateIconGrid = ({ displayedRisks }) => {
    const { deviceType } = useContext(WindowSizeContext);
    return (
        <div className={`climate-icon-grid ${deviceType}`}>
            {displayedRisks.map((risk, index) => (
                <ClimateIcon
                    key={risk.id}
                    risk={risk}
                    riskLevel={risk.riskLevel}
                    index={index}
                />
            ))}
            {/* Connection point for React Flow at bottom center */}
            <div
                id="grid-center-point"
                className="grid-center-point"
            />
        </div>
    );
};

export default ClimateIconGrid;
